import _regenerator from "/var/lib/jenkins/workspace/event-xsj-260120-vue/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/event-xsj-260120-vue/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent as _defineComponent } from 'vue';
import Swiper, { Pagination, EffectCoverflow } from "swiper";
import "swiper/swiper-bundle.min.css";
import { useHead } from "@unhead/vue";
import LangSelect from "@/components/basic/langselect/index.vue";
import BgmAudio from "@/components/basic/audio/audio.vue";
import MobileButton from "@/components/basic/mobile-button.vue";
import { track } from '@/lib/utils';
import IconBgmActive from "@/resources/images/btn-bgm-active.png";
import IconBgm from "@/resources/images/btn-bgm.png";
import Bgm from "@/resources/audio/bgm.mp3";
export default /*#__PURE__*/_defineComponent({
  __name: 'mobile-app',
  setup: function setup(__props) {
    Swiper.use([Pagination, EffectCoverflow]);
    var _useCommon = useCommon(),
      getI18nWord = _useCommon.getI18nWord,
      parseI18nJson = _useCommon.parseI18nJson,
      lang = _useCommon.lang;
    var _storeToRefs = storeToRefs(useFlexStore()),
      rem = _storeToRefs.rem;
    var _useFlexStore = useFlexStore(),
      initFlexiable = _useFlexStore.initFlexiable;
    var BANNER_CNT = 5;
    var bannerSwiper = ref();
    var swiperIndex = computed(function () {
      return bannerSwiper.value ? bannerSwiper.value.realIndex : -1;
    });
    var mediaData = computed(function () {
      if (swiperIndex.value < 0) return [];
      var data = parseI18nJson("media-list");
      return data !== null && data !== void 0 ? data : [];
    });
    useHead({
      title: getI18nWord("web-title")
    });
    initFlexiable();
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            track({
              category: 'page',
              action: 'view'
            });
            _context.n = 1;
            return nextTick();
          case 1:
            bannerSwiper.value = new Swiper(".swiper", {
              width: 6.12 * rem.value * 2,
              watchOverflow: true,
              loop: false,
              pagination: {
                el: ".swiper-pagination",
                // 必须匹配模板中的分页器类名
                type: "bullets"
              },
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
              },
              centeredSlides: true,
              slidesPerView: "auto",
              effect: "coverflow",
              coverflowEffect: {
                rotate: 0,
                stretch: -5,
                depth: 18,
                modifier: 10,
                slideShadows: false
              },
              on: {
                resize: function resize() {
                  if (!bannerSwiper.value) return;
                  bannerSwiper.value.params.width = 6.12 * rem.value * 2;
                  bannerSwiper.value.update();
                }
              }
            });
          case 2:
            return _context.a(2);
        }
      }, _callee);
    })));
    function getRewards(index) {
      if (index < 0) return [];
      var data = parseI18nJson("event-rewards-".concat(index));
      return data !== null && data !== void 0 ? data : [];
    }
    function swiperToPrev() {
      if (!bannerSwiper.value) return;
      track({
        category: 'button',
        action: 'click',
        label: 'LeftArrow'
      });
      bannerSwiper.value.slidePrev();
    }
    function swiperToNext() {
      if (!bannerSwiper.value) return;
      track({
        category: 'button',
        action: 'click',
        label: 'RightArrow'
      });
      bannerSwiper.value.slideNext();
    }
    function clickJoinNow() {
      track({
        category: 'button',
        action: 'click',
        label: 'JoinNow'
      });
      openUrl(getI18nWord('join-now-url'));
    }
    function clickJoinEvent(index) {
      track({
        category: 'button',
        action: 'click',
        label: 'JoinEvent',
        value: index
      });
      openUrl(getI18nWord("event-url-".concat(index)));
    }
    function clickDownload() {
      track({
        category: 'button',
        action: 'click',
        label: 'Download'
      });
      openUrl(getI18nWord('model-download-url'));
    }
    function clickOpenMedia(media) {
      track({
        category: 'button',
        action: 'click',
        label: {
          facebook: 'Fb',
          discord: 'Discord',
          x: 'X',
          ytb: 'Youtube',
          ins: lang !== 'ko-kr' ? 'Ins' : getI18nWord('ins-name')
        }[media]
      });
      openUrl(getI18nWord("".concat(media, "-url")));
    }
    function clickOpenOfficialSite() {
      track({
        category: 'button',
        action: 'click',
        label: 'OfficialSite'
      });
      openUrl(getI18nWord('official-site-url'));
    }
    function openUrl(url) {
      var _window$open;
      if (!window) return;
      (_window$open = window.open(url, "_blank")) === null || _window$open === void 0 || _window$open.focus();
    }
    return {
      __sfc: true,
      getI18nWord: getI18nWord,
      parseI18nJson: parseI18nJson,
      lang: lang,
      rem: rem,
      initFlexiable: initFlexiable,
      BANNER_CNT: BANNER_CNT,
      bannerSwiper: bannerSwiper,
      swiperIndex: swiperIndex,
      mediaData: mediaData,
      getRewards: getRewards,
      swiperToPrev: swiperToPrev,
      swiperToNext: swiperToNext,
      clickJoinNow: clickJoinNow,
      clickJoinEvent: clickJoinEvent,
      clickDownload: clickDownload,
      clickOpenMedia: clickOpenMedia,
      clickOpenOfficialSite: clickOpenOfficialSite,
      openUrl: openUrl,
      LangSelect: LangSelect,
      BgmAudio: BgmAudio,
      MobileButton: MobileButton,
      IconBgmActive: IconBgmActive,
      IconBgm: IconBgm,
      Bgm: Bgm
    };
  }
});